import React from 'react'
import {
    StyledWestLiveWaves,
    StyledWestLiveWaves3,
    StyledWestLiveWaves2,
} from './TheWestLiveWaves.styled'
import { TheWestLiveBroadcast } from '@news-mono/web-common'

interface TheWestLiveWavesProps {
    broadcast?: TheWestLiveBroadcast
}

export const TheWestLiveWaves: React.FC<TheWestLiveWavesProps> = ({
    broadcast,
}) => (
    <React.Fragment>
        <StyledWestLiveWaves broadcast={broadcast} />
        <StyledWestLiveWaves3 broadcast={broadcast} />
        <StyledWestLiveWaves2 broadcast={broadcast} />
    </React.Fragment>
)
TheWestLiveWaves.displayName = 'TheWestLiveWaves'
